import { get } from 'lodash-es';
import Badge from './Badge';
import laravelRoute from 'ziggyRoute';
import { emitter } from '../event-bus';
import { clientApi } from '@phoenix/clientApi';
import { showPanel } from '@phoenix/helpers/panel-helper';
import i18n from '../i18n';
import { orderLinesLocalStorageHelper } from '@phoenix/helpers/product-localstorage-helper';

export default class Bag {
  btns: Array<HTMLInputElement>;
  desktopBadge: Badge;
  mobileBadge: Badge;
  timeoutRemovePromotionBlock: any;

  constructor(addToBagClickCallback: (() => void) | null = null) {
    this.btns = Array.from(document.querySelectorAll('.btn-add-to-cart') as NodeListOf<HTMLInputElement>);
    this.btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const { productReference, productOptions } = btn.dataset;
        if (productReference) {
          this.add(productReference, JSON.parse(productOptions ?? '{}'));
        } else if (addToBagClickCallback !== null) {
          addToBagClickCallback();
        }
      });
    });
  }

  activate() {
    this.btns.forEach((btn) => {
      btn.removeAttribute('disabled');
      btn.classList.remove('btn--disabled', 'hidden', 'sgphx-hidden');
    });
  }

  disable() {
    this.btns.forEach((btn) => {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('btn--disabled');
    });
  }

  hide() {
    this.btns.forEach((btn) => btn.classList.add('hidden', 'sgphx-hidden'));
  }

  setReference(reference) {
    this.btns.forEach((btn) => btn.setAttribute('data-product-reference', reference));
  }

  async add(reference, options) {
    const redirectUrl = options.redirectUrl || null;
    const shouldOpenCartPanel = options.shouldOpenCartPanel ?? true;

    this.btns.forEach((btn) => window.Toolkit.helpers.buttons.addLoadingState(btn));

    let addToBagErrorMessage = null;
    try {
      const response = await clientApi.post(laravelRoute('api.cart.addReference', { reference }));
      if (!get(response, ['data', 'status'], false)) {
        addToBagErrorMessage = i18n.global.t('Error.errorWhileAddingProduct');
      }
      const shoppingTotalCount = Bag.saveShoppingBagTotalFromResponse(response.data);
      emitter.emit('shopping-badge-update', shoppingTotalCount);
    } catch (error) {
      addToBagErrorMessage = get(
        error,
        ['response', 'data', 'message'],
        i18n.global.t('Error.errorWhileAddingProduct'),
      );
    }

    if (addToBagErrorMessage !== null) {
      this.btns.forEach((btn) => window.Toolkit.helpers.buttons.removeLoadingState(btn));
      return Phoenix.toaster.notify({
        type: 'danger',
        text: addToBagErrorMessage,
      });
    }

    tracking.pushEvent(tracking.getAddToCartTracking());

    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    if (shouldOpenCartPanel) {
      showPanel('cart-panel');
    }

    this.btns.forEach((btn) => window.Toolkit.helpers.buttons.removeLoadingState(btn));
    // If the user is on mobile, we hide the size selector
    const sizeStep1 = document.getElementById('choose-a-size-step-1');
    const sizeStep2 = document.getElementById('choose-a-size-step-2');
    if (sizeStep1) {
      sizeStep1.classList.remove('hidden');
    }
    if (sizeStep2) {
      sizeStep2.classList.add('hidden');
    }

    return true;
  }

  static saveShoppingBagTotalFromResponse(data) {
    const shoppingBagTotal = get(data, ['cart', 'items'], []).length;
    orderLinesLocalStorageHelper.save(shoppingBagTotal);
    return shoppingBagTotal;
  }
}
